import { createContext, useState, useEffect } from 'react';

const UserContext = createContext();

const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState({});

   useEffect(() => {
    const saved = localStorage.getItem('userData');
    if (saved) {
      setUserData(JSON.parse(saved));
    }
  }, []);

  // ฟังก์ชัน update userData และเก็บลง localStorage ด้วย
  const updateUserData = (data) => {
    setUserData(data);
    localStorage.setItem('userData', JSON.stringify(data));
  };

  return (
    <UserContext.Provider value={{ userData, setUserData: updateUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserDataProvider, UserContext };
